export const initializeCampaignStats = () => ({
  type: 'INITIALIZE_CAMPAIGN_STATS',
});

export const fetchCampaignStats = resp => ({
  type: 'FETCH_CAMPAIGN_STATS',
  payload: resp,
});
